import { Command } from 'commands/Commands';

export class ChangeAddressState extends Command {
  type: string = 'ChangeAddressState';
  priority: number = 100;
}
